export default __webpack_public_path__ + "static/team-foto-2024-f9db36bd8a653a4ef2b5ef2e3de28678.jpg";